// extracted by mini-css-extract-plugin
var _1 = "TextListItem-moduleTextListItem__KEr4C";
var _2 = "TextListItem-modulelink__iBiCI";
export { _1 as "TextListItem", _2 as "link" }
